/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'cockpit': {
    width: 16,
    height: 16,
    viewBox: '0 0 29.12 25.29',
    data: `<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M14.56 0a15.08 15.08 0 0 1 7.25 1.91l-3.08 1.78a11.31 11.31 0 0 0-4.17-.75 11.39 11.39 0 0 0-8.27 3.38 11.73 11.73 0 0 0-3.42 8.24 12.62 12.62 0 0 0 1 4.58 11.36 11.36 0 0 0 2.46 3.69 1.26 1.26 0 0 1 .48 1 1.41 1.41 0 0 1-.44 1 1.41 1.41 0 0 1-1 .44 1.59 1.59 0 0 1-1.06-.41 14.56 14.56 0 0 1-3.11-4.61A14.33 14.33 0 0 1 0 14.56 14.53 14.53 0 0 1 14.56 0zm0 18.94a4.17 4.17 0 0 1-3.08-1.23 4.5 4.5 0 0 1-1.3-3.14 4.13 4.13 0 0 1 .62-2.22 4.42 4.42 0 0 1 1.57-1.54L26.52 2.6l-8.06 13.94a4.3 4.3 0 0 1-1.57 1.74 4.25 4.25 0 0 1-2.33.66zm14.56-4.37a14.33 14.33 0 0 1-1.12 5.7 14.58 14.58 0 0 1-3.11 4.61 1.59 1.59 0 0 1-1.06.41 1.3 1.3 0 0 1-1-.44 1.47 1.47 0 0 1-.41-1 1.35 1.35 0 0 1 .41-1 12.18 12.18 0 0 0 3.42-8.27 11.31 11.31 0 0 0-.82-4.24l1.78-3a15.08 15.08 0 0 1 1.91 7.22z" id="Ebene_1" data-name="Ebene 1"/></g>`
  }
})



// WEBPACK FOOTER //
// ./src/icons/cockpit.js